import CashOutEdit from "pages/secure/facility/settings/cashOuts/CashOutEdit";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UIActions from "redux/actions/ui";

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

const mapStateToProps = (state: any) => {
  return {
    permissions: { ...state.authStore.user.permissions },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CashOutEdit);
